<template>
    <div class="mingtang hml_whplt">
        <swiperList :swiperStyle="{padding: '2.25rem .4rem .5rem'}">
            <li
            class="mingtangSilde"
            v-for="(item,index) in list"
            :key="index"
            @click="sildeClick(item)"
            >
                <div class="img">
                    <img :src="item.thumb">
                </div>
                <div class="textBox">
                    <h2 class="title">{{ item.title }}</h2>
                    <p>{{ item.description }}</p>
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>

export default {
    data() { 
        return {
        }
    },
    created(){
        this.list.sort((a,b) => {
            return b.listorder - a.listorder  ;
        })
    },
    methods: {
        sildeClick(item){
            this.$emit("sildeClick",item,1)
        }
    },
    props: {
        list: {
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
.mingtang{
    padding-top: 2.25rem;
    .mingtangSilde{
        width: 6.7rem;
        height: 3.76rem;
        box-shadow:0px .04rem .1rem 0px rgba(41,41,41,0.2);
        border-radius: .1rem;
        margin-bottom: .32rem;
        background: #fff;
        overflow: hidden;
        position: relative;
        .img{
            width: 100%;
            height: 100%;
            img{
                // width: 3rem;
                // height: 1.92rem;
                height: 100%;
            }
        }
        .textBox{
            width: 100%;
            height: 1.5rem;
            position: absolute;
            left: 0;
            bottom: 0;
            padding-top: .5rem;
            padding-left: .24rem;
            background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.5), rgba(0,0,0,0.9));
            .title{
                font-size: .46rem;
                color: #fff;
                font-family: "siyuan";
                font-weight: bold;
            }
            p{
                font-size: .24rem;
                color: #fff;
                margin-top: .16rem;
            }
        }
    }
}
</style>